module.exports = __webpack_public_path__ + "static/media/normon.30932481.jpg";